export default "__VITE_ASSET__Dz$8D$Ra__"